import { BrowserCacheLocation, Configuration, PopupRequest, PublicClientApplication } from "@azure/msal-browser";

export const CLIENT_ID = "02523c40-99cf-4e42-ae60-cf6c9970c2bf";

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: "https://login.microsoftonline.com/045c0c45-3c80-4b73-b52f-42f07d6207d4",
    knownAuthorities: ["https://login.microsoftonline.com"],
    // Default target for silent-renewal iframes and login popups only — must be a static
    // page that does not bootstrap React/MSAL, or the hidden iframe re-inits MSAL and
    // trips block_iframe_reload. Top-level redirect flows override this back to "/".
    redirectUri: "/redirect.html",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowRedirectInIframe: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: [CLIENT_ID + "/.default"],
};

// Singleton MSAL instance — exported here (not from AuthProvider) to avoid
// circular imports between api/client.ts and auth/AuthProvider.tsx
export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
await msalInstance.handleRedirectPromise();
